namespace Nobox.Common {
    export interface DashboardPageModel {
        Campaign?: number;
        Contact?: number;
        List?: number;
        dbSize?: number;
        fileSize?: number;
        totalSize?: number;
        avaibleDisk?: number;
        dbSizeNm?: string;
        fileSizeNm?: string;
        totalSizeNm?: string;
        avaibleDiskNm?: string;
        avaibleDiskPercentage?: string;
        usedDiskPercentage?: string;
        totalSizeDisk?: string;
        stroageLimit?: boolean;
        ContactCountry?: { [key: string]: number };
        totalCampaign?: Common.Pages.campaignGroup[];
        doneCampaign?: Common.Pages.campaignGroup[];
        notif?: CRM.NotifRow[];
        Todo?: TodoRow[];
    }
}
